import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Breadcrumb,
  Button,
  Card,
  Col,
  Container,
  Row,
} from "react-bootstrap";

import {
  CustomPaging,
  EditingState,
  PagingState,
  SortingState,
  SearchState,
} from '@devexpress/dx-react-grid';

import {
  Grid,
  PagingPanel,
  Table,
  TableHeaderRow,
  TableEditColumn,
  SearchPanel,
  Toolbar,
} from '@devexpress/dx-react-grid-bootstrap4';

import Moment from 'moment';

import PopupEditing from 'components/ReactTable/PopupEditing.js';
import { useAlert, TYPES } from 'hooks/use-alert-hook.js';
import Popup from './Popup.js';

import {Loading} from 'components/Loading/loading';

const SORT_FIELD_MAP = {
  EMP_ID: 'employee.EMP_NAME',
}

export default function Index() {

  const [swal, setSwal] = useAlert();
  const [columns] = useState([
    { name: 'AUDITOR_ID', title: 'ID' },
    { name: 'EMP_ID', title: 'Employee Name', getCellValue: row => (row.employee) ? row.employee.EMP_NAME : `n-a` },
    { name: 'AUDITOR_STATUS', title: 'Status' },
    { name: 'START_DATE', title: 'Start Date', getCellValue: row => (row.START_DATE) ? Moment(row.START_DATE).format('DD MMMM YYYY') : `-` },
    { name: 'END_DATE', title: 'End Date', getCellValue: row => (row.END_DATE) ? Moment(row.END_DATE).format('DD MMMM YYYY') : `-` },
    { name: 'DECREE_ADRR', title: 'Decree', getCellValue: row => (
      <Button as="a" variant="info" target="blank" href={`${process.env.REACT_APP_API_HOST}auditors/${row.AUDITOR_ID}/download`}>Download</Button>
    )},
  ]);
  const [rows, setRows] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(5);
  const [pageSizes] = useState([5, 10, 15]);
  const [searchValue, setSearchValue] = useState('');
  const [loading, setLoading] = useState(false);
  const [sorting, setSorting] = useState([{ columnName: 'AUDITOR_ID', direction: 'asc' }]);


  const commitChanges = async ({ added, changed, deleted }) => {

    try {
      let formData = new FormData();

      if (added) {

        const newItem = {...added.pop()};

        Object.keys(newItem).forEach(function(key) {
          formData.append(key, newItem[key]);
        });

        const response = await axios.post(`${process.env.REACT_APP_API_HOST}auditors`,
          formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (response.status !== 200) {
          throw new Error(`Create new error`);
        }

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Scope successfuly added`,
            message: ``,
          }
        });

        return fetchData(),  [searchValue, pageSize, currentPage];

      }

      if (changed) {
        const id = Object.keys(changed).pop();
        const updatedItem = { ...changed[id] };

        formData.append('AUDITOR_ID', id);
        Object.keys(updatedItem).forEach(function(key) {
          formData.append(key, updatedItem[key]);
        });

        const response = await axios.post(`${process.env.REACT_APP_API_HOST}auditors`,
          formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            }
          }
        );
        if (response.status !== 200) {
          throw new Error(`Update data error`);
        }

        setSwal({
          type: TYPES.SUCCESS,
          payload: {
            title: `Scope successfuly updated`,
            message: ``,
          }
        });

        return fetchData();
      }

      if (deleted) {
        const item = rows.find(row => row.AUDITOR_ID === [...deleted].pop());
        const onSuccessCallback = async () => {
          const response = await axios.delete(`${process.env.REACT_APP_API_HOST}auditors/${item.AUDITOR_ID}`);
          if (response.status !== 204) throw new Error('Update error');
          return fetchData();
        }

        setSwal({
          type: TYPES.CONFIRM,
          payload: {
            title: `Are you sure`,
            message: `You are about to delete "${item.employee.EMP_NAME}" scope.`,
            onSuccess: {
              title: `Success`,
              message: `Delete Success`,
              callback: onSuccessCallback,
            }
          }
        });
      }

    } catch (error) {
      if (error.response.status === 422) {
        //overlapse period
        setSwal({
          type: TYPES.ERROR,
          payload: {
            message: error.response.data.message,
          }
        });

      }else{

        setSwal({
          type: TYPES.ERROR,
          payload: {
            message: error.toString(),
          }
        });

      }

     }

  };

  const getRowId = row => row.AUDITOR_ID;

  const fetchData = async () => {

    setLoading(true);

    try {

      const orderBy = sorting?.[0];
      const response = await axios.get(`${process.env.REACT_APP_API_HOST}auditors`, {
        params: {
          page: currentPage + 1,
          'per-page': pageSize,
          'search': searchValue,
          expand: 'employee',
          sort: `${orderBy?.direction === 'desc' ? '-' : ''}${SORT_FIELD_MAP[orderBy?.columnName] ?? orderBy?.columnName}`
        }
      });

      if (response.status !== 200) throw new Error(`Fetch error`);

      setRows(response.data.items);
      setTotalCount(response.data._meta.totalCount);

    } catch (error) {
      setSwal({
        type: TYPES.ERROR,
        payload: {
          message: error.toString(),
        }
      });
    }
    setLoading(false);
  }

  useEffect(fetchData, [searchValue, pageSize, currentPage, sorting]);

  return (
    <>
      {swal}
      <Container fluid>
        <Breadcrumb>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Master
          </Breadcrumb.Item>
          <Breadcrumb.Item href="#pablo" onClick={(e) => e.preventDefault()}>
            Auditor
          </Breadcrumb.Item>
          <Breadcrumb.Item aria-current="page" active>
            Index
          </Breadcrumb.Item>
        </Breadcrumb>

        {rows && (
          <Row>
            <Col md="12">
              <Card>
                <Card.Header>
                  <Card.Title as="h4">Auditor List</Card.Title>
                </Card.Header>
                <Card.Body>
                  <Grid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowId}
                  >
                    <SearchState onValueChange={setSearchValue} />

                    <SortingState
                      sorting={sorting}
                      onSortingChange={setSorting}
                    />

                    <PagingState
                      currentPage={currentPage}
                      onCurrentPageChange={setCurrentPage}
                      pageSize={pageSize}
                      onPageSizeChange={setPageSize}
                    />
                    <CustomPaging totalCount={totalCount} />
                    <EditingState
                      onCommitChanges={commitChanges}
                    />
                    <Table />
                    <TableHeaderRow showSortingControls />
                    <TableEditColumn
                      showAddCommand
                      showEditCommand
                      showDeleteCommand
                    />
                    <PopupEditing popupComponent={Popup} />

                    <PagingPanel
                      pageSizes={pageSizes}
                    />
                    <Toolbar />
                    <SearchPanel />
                    {loading && <Loading />}
                  </Grid>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        )}
      </Container>
    </>
  )
}

